import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FileExtPipe} from './file-ext.pipe';
import {FileIconPipe} from './file-icon.pipe';
import {FileFormatService} from './file-format.service';
import {FileListComponent} from "./list/file-list.component";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        FileIconPipe,
        FileExtPipe,
        FileListComponent
    ],
    exports: [
        FileIconPipe,
        FileExtPipe,
        FileListComponent,
    ],
    providers: [FileFormatService]
})
export class FileListModule {
}
